import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "data-item__section-title" };
const _hoisted_2 = { class: "delivery-group__target-date" };
const _hoisted_3 = { class: "order-items" };
const _hoisted_4 = {
    key: 0,
    class: "order-items__none"
};
const _hoisted_5 = { class: "table table--condensed" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { class: "order-items__title" };
const _hoisted_8 = { class: "order-items__money" };
const _hoisted_9 = { class: "order-items__money" };
const _hoisted_10 = {
    key: 0,
    class: "delivery-group__price"
};
import CartItemAdd from "./CartItemAdd.vue";
import CartItemRow from "./CartItemRow.vue";
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import Price from "./Price.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CartDeliveryGroup',
    props: {
        delivery: {},
        order: {},
        loading: { type: Boolean },
        addCartItems: { type: Function },
        addWatchlistItem: { type: Function },
        allowOrderingUnitSelection: { type: Boolean }
    },
    emits: [
        'item-quantity-change',
        'item-params-change',
        'item-remove',
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        function onItemQuantityChange(item, quantity) {
            emit('item-quantity-change', item, quantity);
        }
        function onItemParamsChange(item, params) {
            emit('item-params-change', item, params);
        }
        function removeCartItem(item) {
            emit('item-remove', item);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["data-item__section delivery-group", { 'delivery-group--loading': __props.loading }])
            }, [
                _createElementVNode("h3", _hoisted_1, [
                    (__props.delivery.deliveryArrangement?.targetDate)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.$t('orders.delivery_on')) + " ", 1),
                            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$date(__props.delivery.deliveryArrangement.targetDate)), 1)
                        ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.$t('orders.articles_without_delivery_date')), 1)
                        ], 64))
                ]),
                _cache[14] || (_cache[14] = _createTextVNode()),
                _createElementVNode("div", _hoisted_3, [
                    (__props.order.items.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('order.no_items_order_management')), 1))
                        : _createCommentVNode("", true),
                    _cache[11] || (_cache[11] = _createTextVNode()),
                    _createElementVNode("table", _hoisted_5, [
                        (__props.delivery.items.length > 0)
                            ? (_openBlock(), _createElementBlock("thead", _hoisted_6, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('order.itemSku')), 1),
                                    _cache[0] || (_cache[0] = _createTextVNode()),
                                    _cache[1] || (_cache[1] = _createElementVNode("th", null, null, -1)),
                                    _cache[2] || (_cache[2] = _createTextVNode()),
                                    _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('orders.item_title')), 1),
                                    _cache[3] || (_cache[3] = _createTextVNode()),
                                    _cache[4] || (_cache[4] = _createElementVNode("th", null, null, -1)),
                                    _cache[5] || (_cache[5] = _createTextVNode()),
                                    _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('orders.unit_price')), 1),
                                    _cache[6] || (_cache[6] = _createTextVNode()),
                                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('orders.item_quantity')), 1),
                                    _cache[7] || (_cache[7] = _createTextVNode()),
                                    _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('orders.item_price')), 1),
                                    _cache[8] || (_cache[8] = _createTextVNode()),
                                    _cache[9] || (_cache[9] = _createElementVNode("th", null, null, -1))
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _cache[10] || (_cache[10] = _createTextVNode()),
                        _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.delivery.items, (item) => {
                                return (_openBlock(), _createBlock(CartItemRow, {
                                    key: item.id,
                                    item: item,
                                    "tax-included": __props.order.taxIncluded,
                                    onItemQuantityChange: onItemQuantityChange,
                                    onItemParamsChange: onItemParamsChange,
                                    onItemRemove: removeCartItem
                                }, null, 8, ["item", "tax-included"]));
                            }), 128))
                        ])
                    ]),
                    _cache[12] || (_cache[12] = _createTextVNode()),
                    (__props.loading)
                        ? (_openBlock(), _createBlock(Spinner, {
                            key: 1,
                            loading: true
                        }))
                        : _createCommentVNode("", true),
                    _cache[13] || (_cache[13] = _createTextVNode()),
                    (__props.order.expectedDeliveries.length < 2)
                        ? (_openBlock(), _createBlock(CartItemAdd, {
                            key: 2,
                            "add-cart-items": __props.addCartItems,
                            "add-watchlist-item": __props.addWatchlistItem,
                            "allow-ordering-unit-selection": __props.allowOrderingUnitSelection,
                            order: __props.order
                        }, null, 8, ["add-cart-items", "add-watchlist-item", "allow-ordering-unit-selection", "order"]))
                        : _createCommentVNode("", true)
                ]),
                _cache[15] || (_cache[15] = _createTextVNode()),
                (__props.order.expectedDeliveries.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(Price, {
                            currency: __props.order.currency,
                            amount: __props.order.taxIncluded ? __props.delivery.itemsPricing.grossPriceFormatted : __props.delivery.itemsPricing.netPriceFormatted
                        }, null, 8, ["currency", "amount"])
                    ]))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
